var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40749 0L0 1.175L4.57186 5L0 8.825L1.40749 10L7.39683 5L1.40749 0Z",
    fill: "#F15A28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/Path.4066143a8c39e373df245cae45ee9a1e.svg";
export { ForwardRef as ReactComponent };